import { animalQueries } from '@/queries/animal'
import { orderQueries } from '@/queries/order'
import { productQueries } from '@/queries/product'
import { subscriptionQueries } from '@/queries/subscription'

/**
 * The set of preloadable data "domains" a route can declare it needs via its `<route>` meta (`meta.requires`).
 *
 * The router guard ensures the declared domains are in the query cache before the route resolves, so components can
 * consume the data as guaranteed-present (see `useRouteData`).
 *
 * This is the single source of truth mapping a domain name to its query factory.
 */
export const dataDomains = {
  subscriptions: () => subscriptionQueries.list(),
  dogs: () => animalQueries.list(),
  orders: () => orderQueries.list(),
  products: () => productQueries.list(),
  metadata: () => animalQueries.meta(),
} as const

export type DataDomain = keyof typeof dataDomains
